var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image__container"},[_c('img',{ref:"img",staticClass:"image__img",attrs:{"src":_vm.imageUrl,"alt":_vm.imageAlt},on:{"load":_vm.changeAngleIfNeeded}})])}
var staticRenderFns = []

export { render, staticRenderFns }